var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5,
    d: "M13.556 12.75l4.027 4.028c.223.222.223.583 0 .805-.222.223-.583.223-.805 0l-4.028-4.027-4.028 4.027c-.222.223-.583.223-.805 0-.223-.222-.223-.583 0-.805l4.027-4.028-4.027-4.028c-.223-.222-.223-.583 0-.805.222-.223.583-.223.805 0l4.028 4.027 4.028-4.027c.222-.223.583-.223.805 0 .223.222.223.583 0 .805l-4.027 4.028z",
    transform: "translate(.25 .25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.6ce3b918d9a90f5fdcb12213fdcf3753.svg";
export { ForwardRef as ReactComponent };